import { CALENDAR } from './index';
import { Action } from '../action';

export class CalendarDestroyAction implements Action {
	readonly type = CALENDAR.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class CalendarInitAction implements Action {
	readonly type = CALENDAR.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
